module.exports = __webpack_public_path__ + "static/media/4641.bd26d78f.jpg";